import {
  useAnalyticalVariableListQuery,
  type AnalyticalVariableListItem,
} from '@verantos-dev/feature-analytical-variables';
import type { ListResponse } from '@verantos-dev/types-common';

/**
 * Data grid fetch hook for the AV library list.
 * Wraps the TanStack Query list hook in the shape expected by the DataGrid component.
 */
export const useAvLibraryDataGridFetch = (
  searchParams?: string
): {
  data: ListResponse<AnalyticalVariableListItem> | undefined;
  isLoading: boolean;
  isFetching: boolean;
  isUninitialized: boolean;
  error: unknown;
} => {
  const { data, isLoading, isFetching, isPending, error } =
    useAnalyticalVariableListQuery(searchParams);

  return {
    data,
    isLoading,
    isFetching,
    isUninitialized: isPending && !data,
    error,
  };
};
